/**
 * @Author: 韩祺涛
 * @Date: 2022-12-01
 * @Project: 杭氧客户现场使用
 */
export default {
  state: {
    sparePartsManagementId: {}
  },
  getters: {
    sparePartsManagementId: state => state.sparePartsManagementId
  },
  mutations: {
    sparePartsManagementId: (state, data) => {
      state.sparePartsManagementId = data
    }
  },
  actions: {
    handleSparePartsManagementCompanyId (sparePartsManagementId, data) {
      sparePartsManagementId.commit('sparePartsManagementId', data)
    }
  }
}
